module.exports = __webpack_public_path__ + "static/media/icon_sneak_peek@3x.3da534b2.png";